import camelcaseKeys from 'camelcase-keys';
import { WarrantyTypes } from '../types';
export const parseWarranty = (warranty) => {
    var _a, _b, _c, _d;
    const { name, ...others } = warranty;
    const sanitizedName = name.replace(/[\n\r]/g, '');
    const isFrench = sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.includes('ans');
    const isFlexible = (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.includes('Years or')) || (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.includes('Year or')) || (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.includes('ans ou'));
    if ((warranty === null || warranty === void 0 ? void 0 : warranty.typeName) === 'Standard') {
        const parsedName = (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.replace('* ', '')) || '';
        const [years, kms] = parsedName.split('/') || [];
        const annualKmsStr = (kms === null || kms === void 0 ? void 0 : kms.replace(' km', '')) || '';
        const yearsStr = (years === null || years === void 0 ? void 0 : years.replace(' Year', '').replace(' ans', '')) || '';
        return {
            name: sanitizedName,
            bapType: WarrantyTypes.Standard,
            years: Number(yearsStr),
            yearsText: years !== null && years !== void 0 ? years : '',
            annualKms: Number(annualKmsStr === null || annualKmsStr === void 0 ? void 0 : annualKmsStr.replace(',', '')),
            ...others,
        };
    }
    if (warranty === null || warranty === void 0 ? void 0 : warranty.isRecommended) {
        const parsedName = (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.replace('* ', '')) || '';
        const [years, kms] = parsedName.split('/') || [];
        const annualKmsStr = (kms === null || kms === void 0 ? void 0 : kms.replace(' km', '')) || '';
        const yearsStr = (years === null || years === void 0 ? void 0 : years.replace(' Year', '').replace(' ans', '')) || '';
        return {
            name: sanitizedName,
            bapType: WarrantyTypes.Recommended,
            years: Number(yearsStr),
            yearsText: String(years),
            annualKms: Number(annualKmsStr === null || annualKmsStr === void 0 ? void 0 : annualKmsStr.replace(',', '')),
            ...others,
        };
    }
    if (isFlexible) {
        const parts = (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.split(': ')) || [];
        const delimeter = isFrench ? ' ou ' : ' or ';
        const [years, annualKms] = ((_a = parts[1]) === null || _a === void 0 ? void 0 : _a.split(delimeter)) || [];
        const annualKmsStr = (annualKms === null || annualKms === void 0 ? void 0 : annualKms.replace(' km', '')) || '';
        const yearsStr = ((_c = (_b = years === null || years === void 0 ? void 0 : years.replace(' Years', '')) === null || _b === void 0 ? void 0 : _b.replace(' Year', '')) === null || _c === void 0 ? void 0 : _c.replace(' ans', '')) || '';
        return {
            name: sanitizedName,
            bapType: WarrantyTypes.Flexible,
            years: Number(yearsStr),
            yearsText: years !== null && years !== void 0 ? years : '',
            annualKms: Number(annualKmsStr === null || annualKmsStr === void 0 ? void 0 : annualKmsStr.replace(',', '').replace('*', '')),
            ...others,
        };
    }
    const parsedName = (sanitizedName === null || sanitizedName === void 0 ? void 0 : sanitizedName.replace('* ', '')) || '';
    const [years, kms] = parsedName.split('/') || [];
    const annualKmsStr = (kms === null || kms === void 0 ? void 0 : kms.replace(' km', '')) || '';
    const yearsStr = ((_d = years === null || years === void 0 ? void 0 : years.replace(' Year', '')) === null || _d === void 0 ? void 0 : _d.replace(' ans', '')) || '';
    return {
        name: sanitizedName,
        bapType: WarrantyTypes.Extended,
        years: Number(yearsStr),
        yearsText: years !== null && years !== void 0 ? years : '',
        annualKms: Number(annualKmsStr === null || annualKmsStr === void 0 ? void 0 : annualKmsStr.replace(',', '')),
        ...others,
    };
};
const transformWarrantiesResponse = (response) => {
    const camelCasedData = camelcaseKeys(response, { deep: true }) || {};
    return camelCasedData.map(parseWarranty);
};
export default transformWarrantiesResponse;
